import { Typography } from '@mui/material';
import React from 'react';
import { ALLOCATION_METHOD, BILL_FREQUENCY } from 'src/constants/utilities';

/**
 * Whether a utility's allocation method and frequency are its setup's (LB-6186), so a screen only shows them.
 * A saved utility counts as following a setup until its setup has been read and it follows none: a read still running,
 * or one that failed, never opens them.
 */
export const setupOwnsBillingOptions = _ref => {
  let enabled = _ref.enabled,
    isSaved = _ref.isSaved,
    followsSetup = _ref.followsSetup;
  return !!enabled && !!isSaved && followsSetup !== false;
};

/**
 * The allocation method and frequency a setup gives the utilities that follow it, in the names the utility forms hold.
 * A screen takes these after a link applies, so what it shows and what its Save sends are the setup's. property-service
 * keeps a linked utility's own on Save in any case (LB-6186).
 */
export const billingValuesOf = setup => ({
  allocationMethod: ALLOCATION_METHOD[setup.allocationMethod] || setup.allocationMethod,
  billFrequencyType: BILL_FREQUENCY[setup.billFrequencyType] || setup.billFrequencyType
});

/** In place of a field's edit control while the utility's setup owns it. */
export const SetOnSetupNote = () => /*#__PURE__*/React.createElement(Typography, {
  variant: "body2",
  color: "light",
  component: "span"
}, "Set on its setup");

/** For a utility not saved yet: it links to a setup when it is (LB-6182's automatic link). */
export const SetupOnSaveNote = _ref2 => {
  let typeName = _ref2.typeName;
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    component: "p"
  }, "When you save, this utility links to your company's ", typeName || 'matching', " setup with the same settings, or a new setup made from them. You can pick another after saving.");
};